<!-- eslint-disable vue/no-v-text-v-html-on-component -->
<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="AiLegalMentions">
    <div
      v-if="termsTexts"
      :class="{ 'AiLegalMentions-priceBlock': personalData }">
      <ai-typo
        v-for="terms of termsTexts"
        :key="terms.key"
        class="AiLegalMentions-row"
        as="p"
        variant="paragraph-04-regular"
        color="neutral-800">
        {{ terms.description }}
      </ai-typo>

      <div class="AiLegalMentions-linkContent">
        <ai-link
          class="AiLegalMentions-link"
          target="_blank"
          typo-variant="paragraph-04-bold"
          color="neutral-800"
          :text="$t('ux.molecules.legalMentions.generalCtaLabel')"
          :url="$t('legal.generalConditions.url')" />

        <ai-link
          class="AiLegalMentions-link"
          target="_blank"
          typo-variant="paragraph-04-bold"
          color="neutral-800"
          :url="termsAndConditionUrl">
          <ai-typo
            as="span"
            variant="paragraph-04-bold"
            color="neutral-800"
            v-html="$t('ux.molecules.legalMentions.allTermsCtaLabel')" />
        </ai-link>
      </div>
    </div>

    <div v-if="personalData" class="AiLegalMentions-personalData">
      <ai-typo
        class="AiLegalMentions-row"
        as="p"
        variant="paragraph-04-regular"
        color="neutral-800">
        {{ $t('ux.molecules.legalMentions.personalData.terms1') }}

        <ai-link
          class="AiLegalMentions-mail"
          target="_blank"
          :url="`mailto:${$t(
            'ux.molecules.legalMentions.personalData.dataPrivacyMail',
          )}`"
          :text="
            $t('ux.molecules.legalMentions.personalData.dataPrivacyMail')
          " />

        <ai-typo as="span" variant="paragraph-04-regular" color="neutral-800">
          {{ $t('ux.molecules.legalMentions.personalData.terms2') }}
          <ai-link
            class="AiLegalMentions-mail"
            target="_blank"
            :url="`mailto:${$t(
              'ux.molecules.legalMentions.personalData.dataPrivacyMail',
            )}`"
            :text="
              $t('ux.molecules.legalMentions.personalData.dataPrivacyMail')
            " />
        </ai-typo>
      </ai-typo>

      <ai-typo
        class="AiLegalMentions-row"
        as="p"
        variant="paragraph-04-regular"
        color="neutral-800">
        {{ $t('ux.molecules.legalMentions.personalData.terms3') }}

        <ai-link
          class="AiLegalMentions-mail"
          target="_blank"
          :url="homeNavigate"
          :text="$t('ux.molecules.legalMentions.personalData.link')" />

        <ai-typo as="span" variant="paragraph-04-regular" color="neutral-800">
          {{ $t('ux.molecules.legalMentions.personalData.terms4') }}
        </ai-typo>
      </ai-typo>

      <ai-typo as="p" variant="paragraph-04-regular" color="neutral-800">
        {{ $t('ux.molecules.legalMentions.personalData.terms5') }}

        <ai-link
          target="_blank"
          :url="personalDataCharterUrl"
          :text="
            $t('ux.molecules.legalMentions.personalData.dataProtectionLabel')
          " />
      </ai-typo>
    </div>
  </div>
</template>

<script setup lang="ts">
type Props = {
  priceLegalMention?: boolean;
  priceAndCurrenciesLegalMention?: boolean;
  personalData?: boolean;
  lang: string;
  termsType?: 'priceLegalMention' | 'priceAndCurrenciesLegalMention';
};

const props = withDefaults(defineProps<Props>(), {
  priceLegalMention: false,
  priceAndCurrenciesLegalMention: false,
  personalData: false,
  termsType: 'priceLegalMention',
  lang: 'en',
});

const { t } = useI18n();
const localePath = useLocalePath();
const config = useRuntimeConfig();

const baseUrl = computed(() => config.public.allBaseUrl);

const termsTexts = computed(() => {
  switch (props.termsType) {
    case 'priceLegalMention':
      return [
        {
          description: t(
            'ux.molecules.legalMentions.priceLegalMentions.terms1',
          ),
          key: 'terms1',
        },
        {
          description: t(
            'ux.molecules.legalMentions.priceLegalMentions.terms2',
          ),
          key: 'terms2',
        },
        {
          description: t(
            'ux.molecules.legalMentions.priceLegalMentions.terms3',
          ),
          key: 'terms3',
        },
        {
          description: t(
            'ux.molecules.legalMentions.priceLegalMentions.terms4',
          ),
          key: 'terms4',
        },
        {
          description: t(
            'ux.molecules.legalMentions.priceLegalMentions.terms5',
          ),
          key: 'terms5',
        },
        {
          description: t(
            'ux.molecules.legalMentions.priceLegalMentions.terms6',
          ),
          key: 'terms6',
        },
        {
          description: t(
            'ux.molecules.legalMentions.priceLegalMentions.terms7',
          ),
          key: 'terms7',
        },
      ];

    case 'priceAndCurrenciesLegalMention':
      return [
        {
          description: t(
            'ux.molecules.legalMentions.priceAndCurrencies.terms1',
          ),
          key: 'terms1',
        },
        {
          description: t(
            'ux.molecules.legalMentions.priceAndCurrencies.terms2',
          ),
          key: 'terms2',
        },
        {
          description: t(
            'ux.molecules.legalMentions.priceAndCurrencies.terms3',
          ),
          key: 'terms3',
        },
        {
          description: t(
            'ux.molecules.legalMentions.priceAndCurrencies.terms4',
          ),
          key: 'terms4',
        },
        {
          description: t(
            'ux.molecules.legalMentions.priceAndCurrencies.terms5',
          ),
          key: 'terms5',
        },
      ];
  }
});

const termsAndConditionUrl = computed(
  () =>
    `${baseUrl.value}/loyalty-program/legal/terms-and-conditions-${props.lang}.pdf`,
);

const personalDataCharterUrl = computed(
  () =>
    `${baseUrl.value}/information/legal/data-protection.${props.lang}.shtml`,
);

const homeNavigate = localePath({
  name: 'index',
});
</script>

<style scoped lang="scss">
@use '@/assets/styles/utilities/constants';
@use '@/assets/styles/utilities/mq';
@use '@/assets/styles/utilities/colors';

.AiLegalMentions {
  width: 100%;
  padding-bottom: constants.$padding-03;

  @media (mq.$from-medium) {
    padding-bottom: constants.$padding-04;
  }
}

.AiLegalMentions-row {
  margin-bottom: constants.$margin-02;
}
.AiLegalMentions-linkContent {
  display: flex;
  flex-direction: column;
}

.AiLegalMentions-link {
  display: inline;
  text-decoration: underline colors.$stratos-900;

  &:first-child {
    margin-bottom: constants.$inner-01;
  }
}

.AiLegalMentions-mail {
  margin-left: constants.$inner-01;
}

.AiLegalMentions-priceBlock {
  margin-bottom: constants.$margin-02;
}
</style>
